<template>
  <!-- 添加优惠券 -->
  <my-popup title="创建发放型优惠券" width="800" :flag="isShow" @close="addCouponChange" style="z-index: 3000">
    <div class="add-coupon">
      <!-- 头部 -->
      <!-- <header class="navTab">
        <span :class="{ active: navIsAcitev == 1 }" @click="navIsAci(1)"
          >东券</span
        >
        <span :class="{ active: navIsAcitev == 0 }" @click="navIsAci(0)"
          >京券</span
        >
        <div class="line"></div>
      </header> -->
      <!-- 表单 -->
      <div class="form" style="margin-top:50px">
        <el-form :model="formOne" :rules="rules" ref="form" label-width="130px">
          <el-form-item label="优惠券类型:" required v-if="navIsAcitev == 1">
            <el-radio-group v-model="formOne.bindType">
              <el-radio :label="1">店铺券</el-radio>
              <el-radio :label="2">商品券</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="优惠券名称:" required>
            <el-input v-model="formOne.name" style="width: 280px" placeholder="请输入优惠券名称"></el-input>
          </el-form-item>

          <el-form-item label="领券时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="formOne.takeBeginTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 135px; font-size: 12px"
                class="time1"
                change="activityTimeChange"
                :clearable="false"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="formOne.takeEndTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 140px; font-size: 12px"
                class="time2"
                change="activityTimeChange"
                :clearable="false"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
          </el-form-item>

          <el-form-item label="券有效期:" required>
            <el-input v-model.number="formOne.days" @input.native="checkputn30" style="width: 136px"></el-input>
            <span class="txt">最大可填写 30 天</span>
          </el-form-item>

          <el-form-item label="优惠方式:" required v-if="navIsAcitev == 1">
            <el-radio v-model="fullDiscount" :label="1">满减券</el-radio>
          </el-form-item>
          <el-form-item label="限领规则:" required>
            <el-radio-group v-model="formOne.takeRule">
              <el-radio :label="5">每人限领一张</el-radio>
              <el-radio :label="4">每人每天限领一张</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="优惠信息:" required v-if="navIsAcitev == 1">
            <div>
              满
              <el-input v-model="formOne.quota" style="width: 136px" @input.native="checkputn1"></el-input>
              减
              <el-input v-model="formOne.discount" @input.native="checkputn1" style="width: 136px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="优惠券面值:" required v-if="navIsAcitev == 0">
            <el-input v-model="formOne.discount" @input.native="checkputn1" style="width: 136px"></el-input>
            元
          </el-form-item>
          <el-form-item label="发放数量:" required>
            <el-input v-model.number="formOne.num" @input.native="checkputn1" style="width: 136px"></el-input>
            张
          </el-form-item>

          <el-form-item label="优惠券适用商品:" required v-if="formOne.bindType == 2 && navIsAcitev == 1">
            <span style="margin-right: 40px; font-size: 14px">
              优惠券适用商品 共
              <span style="color: #fe4d45">{{ numSku }}</span
              >个sku</span
            >
            <el-button style="" type="primary" @click="goodsState = true">选择商品</el-button></el-form-item
          >
        </el-form>
      </div>
      <!-- 底部 -->
      <footer class="foot">
        <el-button class="cancel" @click="addCouponChange">取消</el-button>
        <el-button class="confirm" @click="setCoupon" type="primary">确认</el-button>
      </footer>
    </div>

    <!-- 选择商品弹窗 -->
    <!-- <select-goods
      :isShow="goodsState"
      :selectGoods="returnSelectGoods"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
    ></select-goods> -->
    <select-goods v-if="goodsState" @transferName="selectGoodsChange" :postForm="returnSelectGoods"> </select-goods>
  </my-popup>
</template>

<script>
import myPopup from "../../components/myPopup";
import inputForm from "../../components/inputForm";
import SelectGoods from "../../components/selectGoodsMonitor";
import { createSellerCouponWrite } from "@/api/integralCenter/couponWriteController.js";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    myPopup,
    inputForm,
    SelectGoods,
  },
  data() {
    return {
      numSku: 0,
      goodsState: false,
      returnSelectGoods: [],
      // totalShopList: 0,
      // currentShopPage: 1,
      fullDiscount: 1,
      navIsAcitev: 1,
      formOne: {
        bindType: null,
        name: "",
        takeBeginTime: "",
        takeEndTime: "",
        days: null,
        takeRule: null,
        quota: null,
        discount: null,
        num: null,
      },
      rules: {},
      startTime: null,
      endTime: null,
      // tableShopData: [],
      ids: 0,
      postForm: {
        orderStartTime: "",
        testSelect: 0,
      },
      goodsStateLength: 0,
      goodsStateLength1: 0,
      returnSelectGoodsAppoint: [], //选择商品回显
    };
  },
  methods: {
    addCouponChange() {
      this.$emit("close", false);
      this.formOne.name = "";
      this.formOne.takeBeginTime = "";
      this.formOne.takeEndTime = "";
      this.formOne.days = null;
      this.formOne.takeRule = null;
      this.formOne.discount = null;
      this.formOne.num = null;
      this.formOne.quota = null;
      this.formOne.bindType = null;
    },
    navIsAci(val) {
      if (val == 1) {
        this.navIsAcitev = 1;
        this.formOne.quota = null;
        this.formOne.bindType = null;
      } else {
        this.navIsAcitev = 0;
        this.formOne.quota = 0;
        this.formOne.bindType = 1;
      }
      this.formOne.name = "";
      this.formOne.takeBeginTime = "";
      this.formOne.takeEndTime = "";
      this.formOne.days = null;
      this.formOne.takeRule = null;
      this.formOne.discount = null;
      this.formOne.num = null;
    },
    checkputn1(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
      // if (e.target.value > 30) {
      //   e.target.value = 30;
      // }
    },

    checkputn30(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
        // this.formOne.days = 0;
      }
      if (e.target.value > 30) {
        e.target.value = 30;
        this.formOne.days = 30;
      }
      // console.log(this.formOne.days);
    },

    //创建优惠券
    setCoupon() {
      // if (this.formOne.days != null) {
      //   this.formOne.days = Number(this.formOne.days);
      // }
      if (this.formOne.discount != null) {
        this.formOne.discount = Number(this.formOne.discount);
      }
      // if (this.formOne.num != null) {
      //   this.formOne.num = Number(this.formOne.num);
      // }
      if (this.formOne.quota != null) {
        this.formOne.quota = Number(this.formOne.quota);
      }
      if (this.formOne.takeRule != null) {
        this.formOne.takeRule = Number(this.formOne.takeRule);
      }
      if (parseInt(this.formOne.days) <= 0) {
        this.$message.error("优惠券有效期无效");
        return;
      }
      if (this.formOne.num <= 0) {
        this.$message.error("优惠券发放数量无效");
        return;
      }
      this.formOne.type = Number(this.navIsAcitev);
      console.log(this.formOne);
      createSellerCouponWrite(this.formOne)
        .then((res) => {
          if (res && res.code == 1) {
            this.ids = Number(res.data);
            this.$message.success(res.message);
            this.addCouponChange(); //关闭弹窗
            setTimeout(() => {
              this.$emit("funcMes", this.ids);
            }, 800);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
    },
    clearTime() {
      this.formOne.takeBeginTime = "";
      this.formOne.takeEndTime = "";
    },
    // 商品组件回调
    selectGoodsChange(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          let aaa = [];
          let itemListFor = [];
          newArr.forEach((item, index) => {
            let fomeVaule = {};
            aaa.push(Number(item.skuId));
            fomeVaule.skuId = newArr[index].skuId;
            fomeVaule.logo = newArr[index].logo;
            fomeVaule.price = newArr[index].jdPrice || newArr[index].price;
            fomeVaule.title = newArr[index].wareTitle || newArr[index].title;
            itemListFor.push(fomeVaule);
          });
          this.returnSelectGoods = itemListFor;
          this.formOne.skuId = aaa.toString();
          this.formOne.skuId.split(",");
          this.postForm.itemList = newArr;
          this.numSku = newArr.length;
          this.goodsStateLength = this.goodsStateLength1;
          this.returnSelectGoodsAppoint = newArr;
        }
      }
      // if (val !== false) {
      //   console.log("商品选择返回==222");
      //   let aaa = [];
      //   let itemListFor = [];
      //   val.forEach((item, index) => {
      //     let fomeVaule = {};
      //     aaa.push(Number(item.skuId));
      //     fomeVaule.skuId = val[index].skuId;
      //     fomeVaule.logo = val[index].logo;
      //     fomeVaule.price = val[index].jdPrice || val[index].price;
      //     fomeVaule.title = val[index].wareTitle || val[index].title;
      //     itemListFor.push(fomeVaule);
      //   });
      //   this.returnSelectGoods = itemListFor;
      //   this.formOne.skuId = aaa.toString();
      //   // let arr =
      //   this.formOne.skuId.split(",");
      //   // console.log(arr, "aaa");

      //   // this.formOne.skuId = arr;

      //   this.postForm.itemList = val;
      //   this.numSku = val.length;
      //   this.goodsStateLength = this.goodsStateLength1;
      //   this.returnSelectGoodsAppoint = val;
      // }
      this.goodsState = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-coupon {
  .navTab {
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 35px;
    margin: 20px 0;
    span {
      flex-shrink: 0;
      width: 106px;
      height: 35px;
      line-height: 34px;
      text-align: center;
      margin-right: 2px;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 2px 2px 0px 0px;
      cursor: pointer;
      &:last-child {
        margin: 0;
      }
    }
    .active {
      border-bottom: none !important;
      border-top: 2px solid #fe4d45;
      border-radius: 4px 4px 0px 0px;
    }
    .line {
      flex: 1;
      border-bottom: 1px solid #ddd;
    }
  }
  .form {
    font-size: 14px;
    color: #333;
    .txt {
      margin-left: 32px;
      color: #999;
    }
  }
  .foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
    .cancel {
      width: 98px;
      height: 32px;
      line-height: 28px;
      // margin-right: 12px;
      // border: 1px solid #ccc;
      // color: #999;
    }
    .confirm {
      width: 98px;
      height: 32px;
      line-height: 28px;
      // background-color: #fe4d45;
      // color: #fff;
    }
  }
  button {
    // border: none;
    // background-color: white;
    // outline: none;
    // cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}
</style>
